import { TLOSModel } from '@/features/common/types';

export const sortTLOSValue = (a: TLOSModel | null, b: TLOSModel | null) => {
  if (a === null || b === null) {
    return a === null ? -1 : 1;
  }

  const parseValueToHours = (value: number, unit: string) => {
    if (!value || !unit) return 0;
    return unit === 'D' ? value * 24 : value;
  };

  const hoursA = parseValueToHours(a?.value, a?.unit);
  const hoursB = parseValueToHours(b?.value, b?.unit);

  return hoursA - hoursB;
};
